import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'
import { TextMaterialTag } from '@@partner:types:app'
import { CommonPager, CommonSort, NestedFilter, PageInfo } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'
import { SHORTCUT_TEXT_MATERIAL_TAG_FIELDS } from '../textMaterialShortcut'


export interface AllTextMaterialTags {
  allTextMaterialTags: {
    edges: TextMaterialTag[]
    pageInfo: PageInfo
  }
}

export interface AllTextMaterialTagsVariables {
  filter?: NestedFilter
  pager: CommonPager
  sort: CommonSort
}

export const GQL_QUERY_ALL_TEXT_MATERIAL_TAGS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allTextMaterialTags(
      filter: $filter
      pager: $pager
      sort: $sort
    ) {
      edges {
        ${SHORTCUT_TEXT_MATERIAL_TAG_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllTextMaterialTags = (variables: AllTextMaterialTagsVariables) =>
  useQuery<AllTextMaterialTags, AllTextMaterialTagsVariables>(
    GQL_QUERY_ALL_TEXT_MATERIAL_TAGS,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )